// extracted by mini-css-extract-plugin
export default {"alertButtons":"Alerts_alertButtons__DmayY"};